import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Footer } from '@components/Layout'
import { Seo } from '@components/Seo'
import { useLang, withLang } from '@shared/i18n/useLang'

interface Props {
  code: '404' | '500'
}

export function ErrorPage({ code }: Props) {
  const { t } = useTranslation()
  const lang = useLang()

  const CONFIG = {
    '404': {
      kicker: t('notFound.kicker'),
      title: t('notFound.title'),
      text: t('notFound.text'),
      secondLink: { to: withLang(lang, '/zayavka'), label: t('notFound.secondLink') },
    },
    '500': {
      kicker: t('serverError.kicker'),
      title: t('serverError.title'),
      text: t('serverError.text'),
      secondLink: { to: withLang(lang, '/kontakty'), label: t('serverError.secondLink') },
    },
  }

  const c = CONFIG[code]

  return (
    <>
      <Seo title={t('seo.notFound.title')} description={t('seo.notFound.description')} noindex />

      <section style={{
        flex: 1,
        background: '#171C22',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '80px 32px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* crosshatch */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'repeating-linear-gradient(45deg, rgba(255,255,255,0.02) 0 2px, transparent 2px 26px)',
          pointerEvents: 'none',
        }} />

        <div style={{
          position: 'relative',
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', gap: 24,
          textAlign: 'center', maxWidth: 640,
        }}>
          {/* kicker */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ width: 8, height: 8, background: '#189BD5', flexShrink: 0 }} />
            <span style={{ fontSize: 11, fontWeight: 600, letterSpacing: '.16em', textTransform: 'uppercase', color: '#93A3AE' }}>
              {c.kicker}
            </span>
            <span style={{ width: 8, height: 8, background: '#189BD5', flexShrink: 0 }} />
          </div>

          {/* big number */}
          <div className="error-code" style={{
            fontWeight: 800,
            letterSpacing: '-.03em', lineHeight: 1,
            color: '#FFFFFF',
            textShadow: '6px 6px 0 rgba(24,155,213,.35)',
          }}>
            {code}
          </div>

          <h1 style={{ margin: 0, fontSize: 28, fontWeight: 700, letterSpacing: '-.01em', color: '#FFFFFF' }}>
            {c.title}
          </h1>

          <p style={{ margin: 0, fontSize: 15, lineHeight: 1.7, color: '#93A3AE' }}>
            {c.text}
          </p>

          <div style={{ display: 'flex', gap: 12, marginTop: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Link
              to={withLang(lang, '/')}
              style={{ background: '#189BD5', color: '#FFFFFF', fontSize: 12, fontWeight: 600, letterSpacing: '.08em', textTransform: 'uppercase', padding: '14px 28px', borderRadius: 3, transition: 'background .15s' }}
            >
              {t('common.toHome')}
            </Link>
            <Link
              to={c.secondLink.to}
              style={{ border: '1px solid #3A434D', color: '#E7EBEE', fontSize: 12, fontWeight: 600, letterSpacing: '.08em', textTransform: 'uppercase', padding: '14px 28px', borderRadius: 3, transition: 'border-color .15s' }}
            >
              {c.secondLink.label}
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}
